import React, { useMemo, useRef, useState } from "react";
import { IconButton, Menu, MenuItem, Stack, Tab, Tabs } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { equals } from "ramda";
import { Menu as MenuIcon } from "@mui/icons-material";

import { RoutePaths } from "src/app/model";

import { pages } from "../../model/constants";

export const Navbar: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const anchorEl = useRef<HTMLButtonElement>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const tabValue = useMemo(() => {
    if (
      equals(location.pathname, RoutePaths.SICHERO) ||
      equals(location.pathname, RoutePaths.SEARCH_AGENT) ||
      equals(location.pathname, RoutePaths.DYNAMIC_PRICING) ||
      equals(location.pathname, RoutePaths.SALES_AGENT)
    ) {
      return RoutePaths.PRODUCTS;
    }
    return location.pathname;
  }, [location.pathname]);

  const handleMenuClick = () => {
    setOpen((prevState) => !prevState);
  };

  const handleMenuItemClick = (path: RoutePaths) => {
    navigate(path);
    setOpen(false);
  };

  const handleCloseMenu = () => {
    setOpen(false);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
          marginLeft: "auto",
        }}
      >
        {pages.map((page) => (
          <Tab
            key={page.value}
            label={page.label}
            value={page.value}
            to={page.value}
            component={Link}
          />
        ))}
      </Tabs>

      <Stack
        marginLeft="auto"
        sx={{
          display: {
            xs: "flex",
            md: "none",
          },
        }}
      >
        <IconButton ref={anchorEl} onClick={handleMenuClick}>
          <MenuIcon />
        </IconButton>

        <Menu
          open={open}
          onClose={handleCloseMenu}
          anchorEl={anchorEl.current}
          sx={{
            " .MuiList-root": {
              paddingY: 0,
            },
          }}
        >
          {pages.map((page) => (
            <MenuItem
              selected={equals(location.pathname, page.value)}
              key={page.value}
              onClick={() => handleMenuItemClick(page.value)}
            >
              {page.label}
            </MenuItem>
          ))}
        </Menu>
      </Stack>
    </>
  );
};
